import type { TFunction } from 'i18next'
import * as Yup from 'yup'
import type { Address } from '@dhl/input-address'
import { createCompanyNameValidationSchema } from '@dhl/inputs'

export const createValidationSchema = (t: TFunction, addressValidationSchema: Yup.Schema<Address>) =>
  Yup.object({
    name: createCompanyNameValidationSchema(t).required(
      t('admin.terminalsPage.terminalFormInputErrorMessage.companyIsRequired')
    ),
    businessUnitCode: Yup.string()
      .default('')
      .required(t('admin.terminalsPage.terminalFormInputErrorMessage.businessUnitCodeIsRequired')),
    data: Yup.object({
      address: addressValidationSchema,
      contactPerson: Yup.object({
        firstName: Yup.string()
          .default('')
          .required(t('admin.terminalsPage.terminalFormInputErrorMessage.firstNameIsRequired')),
        lastName: Yup.string()
          .default('')
          .required(t('admin.terminalsPage.terminalFormInputErrorMessage.lastNameIsRequired')),
        email: Yup.string()
          .default('')
          .email(t('admin.terminalsPage.terminalFormInputErrorMessage.emailAddressIsRequired')),
        phone: Yup.string()
          .default('')
          .matches(/^[\d\s()+-]{9,15}$/, t('admin.terminalsPage.terminalFormInputErrorMessage.phoneIsRequired'))
          .required(t('admin.terminalsPage.terminalFormInputErrorMessage.phoneIsRequired')),
      }),
    }),
    useCompanyAddressBook: Yup.boolean().default(false),
    useSharedShipments: Yup.boolean().default(false),
    useAdvancedParcelType: Yup.boolean().default(false),
    useSharedTickets: Yup.boolean().default(false),
    useSharedImportSchemas: Yup.boolean().default(false),
  }).defined()
